(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elmayorista-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class EMReviewsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-em-review-track]');
      if (!this.track) return;

      this.querySelectorAll('[data-em-review-nav]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.emReviewNav === 'previous' ? -1 : 1;
          const amount = Math.max(this.track.clientWidth * 0.88, 280);
          this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
        });
      });
    }
  }

  if (!customElements.get('em-reviews-carousel')) {
    customElements.define('em-reviews-carousel', EMReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
